import React from 'react';
import { Handle, Position } from '@xyflow/react';

function LoadBalancerNode({ data, selected }) {
  return (
    <div
      className={`relative rounded-lg border-2 p-3 transition-colors ${
        selected
          ? 'border-cyan-600 bg-cyan-50/70 dark:bg-cyan-900/30'
          : 'border-cyan-400 bg-cyan-50/40 dark:bg-cyan-900/20'
      }`}
      style={{ width: 220, height: 120 }}
    >
      <Handle type="target" position={Position.Top} className="!bg-cyan-600" />
      <div className="mb-1 flex items-center gap-2">
        <svg className="h-4 w-4 text-cyan-700 dark:text-cyan-400 shrink-0" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2} aria-hidden="true">
          <line x1="12" y1="2" x2="12" y2="6" />
          <line x1="12" y1="18" x2="12" y2="22" />
          <line x1="4" y1="6" x2="20" y2="6" />
          <line x1="4" y1="18" x2="20" y2="18" />
          <line x1="4" y1="12" x2="20" y2="12" />
        </svg>
        <span className="text-sm font-semibold text-cyan-900 dark:text-cyan-100 truncate">{data.name}</span>
      </div>
      {data.lbSku && (
        <span className="inline-block bg-cyan-100 text-cyan-800 dark:bg-cyan-900 dark:text-cyan-200 text-xs font-mono px-2 py-0.5 rounded">
          {data.lbSku} / {data.lbType || 'Public'}
        </span>
      )}
      <div className="mt-1 text-xs text-gray-500 dark:text-gray-400">Load Balancer</div>
      <Handle type="source" position={Position.Bottom} className="!bg-cyan-600" />
    </div>
  );
}

export default LoadBalancerNode;
